// extracted by mini-css-extract-plugin
export default {"orderHistoryOverview":"bq-z","errorMsg":"cq-z"};